import { EarningsCardProps, StatCardProps } from "../../pages/recommender/dashboard/types";

export const StatCard: React.FC<StatCardProps> = ({
  icon,
  title,
  description,
  value,
  change,
  period,
  positive,
}) => {
  // Parse the change value to determine if it's positive or negative
  // Handle both string and number types
  const changeNumber = change !== undefined && change !== null 
    ? (typeof change === 'string' ? parseFloat(change) : change)
    : 0;
  const isPositive = changeNumber > 0;
  const isNegative = changeNumber < 0;
  
  // Format the change display with + sign for positive, no sign for negative
  const formattedChange = isNegative ? `${Math.abs(changeNumber)}` : `${changeNumber}`;
  const displayChange = isNegative ? `-${formattedChange}` : `+${formattedChange}`;

  return (
    <div className="bg-white rounded-xl p-8 shadow-md">
      <div className="text-gray-600 mb-4">{icon}</div>
      <h3 className="font-semibold text-[#121212] text-[18px] mb-1">{title}</h3>
      <p className="text-[14px] text-[#8494AE] mb-4">{description}</p>
      <div className="flex items-end gap-3">
        <span className="text-[22px] font-bold text-[#333D4D]">{value}</span>
        {change !== undefined && change !== null && (
          <span className={`
            text-sm font-medium px-2 py-1 rounded-full
            ${isPositive ? 'bg-[#00A86B] text-[#fff]' : isNegative ? 'bg-[#F37A50] text-[#fff]' : 'bg-[#8494AE] text-[#fff]'}
          `}>
            {displayChange}%
          </span>
        )}
      </div>
      {period && <p className="text-sm text-[#121212] text-[12px] mt-2">{period}</p>}
    </div>
  );
};

export const EarningsCard: React.FC<EarningsCardProps> = ({ icon, title, description, value }) => (
  <div className="bg-white rounded-xl p-12 shadow-sm">
    <div className="text-gray-600 mb-4">{icon}</div>
    <h3 className="font-semibold text-[18px] text-[#121212]">{title}</h3>
    <p className="text-xs text-[#8494AE] mb-4">{description}</p>
    <span className="text-[22px] font-semibold text-[#00A86B]">{value}</span>
  </div>
);